import { toQueryString } from '@griply/utils';

export const replaceUrlParams = (
  url: string,
  urlParams: Record<string, string | number | boolean> = {},
  queryParams: Record<string, string | string[]> = {},
) => {
  const queryString = toQueryString(queryParams);

  const replacedUrl = Object.entries(urlParams).reduce(
    (acc, [key, value]) => acc.replaceAll(`:${key}`, String(value)),
    url,
  );

  return queryString ? `${replacedUrl}?${queryString}` : replacedUrl;
};
